import React from 'react';

function TermsOfUse() {
  return (
    <div className="legal-page page">
      <div className="white-wrapper">
        <div className='terms-container'>
          <h4>Terms of Use</h4>
          <p><em>Last updated: 15/5/2025</em></p>

          <strong>1. Educational Purpose Only</strong>
          <p>SignMates is made for learning and awareness. It is not a replacement for formal Auslan education or professional advice.</p>

          <strong>2. Free to Use</strong>
          <p>SignMates is free to use for personal and educational purposes. You can explore, play, and learn as much as you like.</p>

          <strong>3. Content Accuracy</strong>
          <p>We do our best to keep the signs and information accurate. However, some signs may differ depending on the region or context.</p>

          <strong>4. Respectful Use</strong>
          <p>Please use this website respectfully. Do not try to copy, change, or misuse the content for commercial purposes.</p>

          <strong>5. Changes to the Site</strong>
          <p>We may update or change parts of the site from time to time to make it better. You’re always welcome to revisit and explore new features.</p>

          <strong>6. External Links</strong>
          <p>Some pages may link to other helpful resources. We are not responsible for the content or rules of those websites.</p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
